<template>
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>应急演练</h6>
			<el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">添加演练</el-button>
			<el-button class="titBtn" type="success" @click="reset" icon="el-icon-refresh">重置</el-button>
			<el-button class="titBtn" type="success" icon="el-icon-search">搜索</el-button>
			<el-input class="querys" v-model.trim="dw" placeholder="应急演练名称"></el-input>
      <el-input class="querys" v-model.trim="dw" placeholder="年份"></el-input>
		</div>

		<div class="tabBody">
			<el-table :data="tabledata" :height="tableHeight" @row-click="rowClick" highlight-current-row border row-key="id" :tree-props="{children: 'subList'}" :header-cell-style="{background:'rgba(49,130,222,0.1)'}">
				<el-table-column type="index" align="center" width="45" label="序号"></el-table-column>
				<el-table-column prop="ydbYlMc" label="演练名称" align="center"></el-table-column>
				<el-table-column prop="ydbYldw" label="演练部门" align="center"></el-table-column>
        <el-table-column prop="ydbYldd" label="演练地点" align="center"></el-table-column>
				<el-table-column prop="ydbKssj" label="演练开始时间" align="center"></el-table-column>
        <el-table-column prop="ydbJssj" label="演练结束时间" align="center"></el-table-column>
				<el-table-column prop="ydbYlfzr" label="演练负责人" align="center"></el-table-column>
        <el-table-column prop="ydbCyry" label="演练参与人员" align="center"></el-table-column>
        <el-table-column prop="ydbYlnr" label="演练内容" align="center"></el-table-column>
        <el-table-column prop="ydbYlpj" label="综合评价" align="center"></el-table-column>
				<el-table-column prop="" label="操作" width="120" align="center">
					<template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看" placement="top-start">
              <el-button type="primary" class="tableedit" icon="el-icon-view" circle @click="view(scope.row,scope.$index)"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
              <el-button type="success" class="tableedit" icon="el-icon-edit" circle @click="edit(scope.row,scope.$index)"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
              <el-button type="warning" class="tableedit" icon="el-icon-delete" circle @click="deletes(scope.row,scope.$index)"></el-button>
            </el-tooltip>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<yjylpopup v-if="dialogVisible == true" :mystate="Addsid" @getcancel="Getcancel" @adddata="Adddata" @bjadddata="bjaddData"></yjylpopup>

    <div class="fye">
    	<pagintion @dsydata='DsyData' @dstdata="DstData" :ToTal='total' :pageNums="pageNums"></pagintion>
    </div>
	</div>
</template>

<script>
  import { yjylList, yjylDelete } from "@/api/api";
	import yjylpopup from "./popup/yjylpopup.vue";
  import pagintion from '@/components/mangement/pagintion.vue';
	export default {
		data() {
			return {
				tabledata: [],
				tableHeight: window.innerHeight - 180,
				total: 0,
				pageSize: 20, //每页多少条数据分页
				pageNum: 1, //当前页
				pageNums: null,
				username: '',
				dw: '',
				dialogVisible: false,
				Addsid: [],
				row:null,
			}
		},
		components: {
			yjylpopup,
      pagintion
		},
		mounted() {
      let params = {
      	pageSize: this.pageSize,
      	pageNum: this.pageNum,
      }
      this.list(params);
		},
		methods: {
      //调用接口获得防汛管理制度列表
      list(params) {
      	yjylList(params).then((res) => {
          this.total = res.total;
          this.tabledata = res.data;
      	})
      },
      Getcancel(data) {
      	this.dialogVisible = data.dialogVisible;
      },
      Adddata(data) {
      	this.dialogVisible = data.dialogVisible;
        let params={
        	pageSize: this.pageSize,
        	pageNum: this.pageNum,
        }
        this.list(params);
      },
      bjaddData(data) {
        this.dialogVisible = data.dialogVisible;
        let params={
        	pageSize: this.pageSize,
        	pageNum: this.pageNum,
        }
        this.list(params);
      },
			addClick() {
        this.Addsid = [];
				this.dialogVisible = true;
				this.Addsid = ["xz"];
			},
      view(row, index) {
        this.Addsid = [];
      	this.dialogVisible = true;
      	this.Addsid = ["ck", row];
      },
			edit(row, index) {
        this.Addsid = [];
				this.dialogVisible = true;
				this.Addsid = ["bj", row];
			},
      rowClick(row) {
      	this.row = row;
      },
			reset(){
				this.dw = '';
			},
			deletes(row, index) {
      	this.$confirm('确定删除当前用户吗?此操作将永久删除, 是否继续?', '提示', {
      		confirmButtonText: '确定',
      		cancelButtonText: '取消',
      		type: 'warning'
      	}).then(action => {
      		if(action === 'confirm') {
            let ids = [];
            ids.push(row.id);
      			yjylDelete(ids).then((res) => {
      				if(res.code == 200) {
      					this.$notify({
      						title: "提示",
      						message: res.message,
      						type: "success",
      					});
      					let params = {
      						pageSize: this.pageSize,
      						pageNum: this.pageNum,
      					}
      					this.list(params)
      				} else {
      					this.$notify({
      						title: "提示",
      						message: res.message,
      						type: "success",
      					});
      				}
      			})
      		}
      	}).catch(() => {
      		this.$message({
      			message: '已取消',
      			type: 'warning'
      		});
      	});
      },
      DsyData(data) { //多少页
      	this.pageNum = data.dsy;
      	let params = {
      		pageSize: this.pageSize,
      		pageNum: this.pageNum,

      	}
      	this.list(params)
      },
      DstData(data) { //多少条
      	this.pageSize = data.dst;
      	let params = {
      		pageSize: this.pageSize,
      		pageNum: this.pageNum,

      	}
      	this.list(params)
      },
		}
	}
</script>

<style scoped>
	@import url('../../../common/css/mangementall.css');
	.querys {
		height: 30px;
		float: right;
		width: 200px;
		margin-top: 10px;
		margin-right: 10px;
	}

	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;
		padding-left: 10px;
		font-size: 14px;
	}
</style>
